export default {
  styleOverrides: {
    root: {
      minHeight: 48,
      "&.Mui-expanded": {
        minHeight: 48,
      },
      "& .MuiAccordionSummary-content": {
        margin: "13px 0",
        "&.Mui-expanded": {
          margin: "13px 0",
        },
      },
    },
  },
};
